import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
  <svg
    id="Vrstva_1"
    className={classes.svg}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1756.7 465.3"
  >
    <style>{".st0{fill:#f03741}.st1{fill:#ffffff}"}</style>
    <path
      className="st0"
      d="M149.1 310.4C82.3 282.2 51 205.1 79.2 138.3s105.3-98.1 172.1-69.9"
    />
    <path
      className="st1"
      d="M261.9 155.2c66.8 28.2 98.1 105.3 69.9 172.1-28.2 66.8-105.3 98.1-172.1 69.9"
    />
    <path className="st0" d="M46.1 342.5h65.3v65.3H46.1z" />
    <circle className="st1" cx={332.6} cy={90.6} r={32.7} />
    <path
      className="st1"
      d="M1030.6 144.5c-13.2-19.8-30.6-31.6-56.1-31.6-27.4 0-42.9 14.2-42.9 33.9 0 18.4 9.4 28.8 68.8 54.7 69.8 31.1 91 60.3 91 105.1 0 57-49 101.8-117.9 101.8-53.8 0-94.8-21.7-123.1-69.3l42.9-30.1 6.4-4.6c17.9 29.7 44.1 47.3 73.3 47.3 29.7 0 50-17.9 50-40.5s-12.7-36.8-70.7-61.3c-65.5-27.3-89.1-56.5-89.1-102.7 0-50.9 44.3-90.5 111.3-90.5 49.5 0 86.7 20.7 109.8 56.6M616.2 144.5c-13.2-19.8-30.6-31.6-56.1-31.6-27.4 0-42.9 14.2-42.9 33.9 0 18.4 9.4 28.8 68.8 54.7 69.8 31.1 91 60.3 91 105.1 0 57-49 101.8-117.9 101.8-53.7 0-94.8-21.7-123-69.3L479 309l6.4-4.6c17.9 29.7 44 47.3 73.3 47.3 29.7 0 50-17.9 50-40.5S596 274.4 538 249.9c-65.5-27.3-89.1-56.5-89.1-102.7 0-50.9 44.3-90.5 111.3-90.5 49.5 0 86.7 20.7 109.8 56.6M732.7 57.9h66v349.6h-66zM1118.8 119.9V56.8h282v63.1h-107.5v288.6h-67V119.9zM1579 56.8h-71.2L1373 408.5h76l25.4-74.6h136.2l25.9 74.6h76L1579 56.8zm-87 223.3 50.6-158.9 50.7 158.9H1492z"
    />
  </svg>
  );
};

export default LogoFull;
